<!-- eslint-disable no-unused-vars -->
<script setup>
import { ref, defineExpose, nextTick, useTemplateRef, defineEmits } from 'vue'
import { updateapprovingfilebyfeild } from '@/port/common/homeworkCorrection.js'
import { updateapprovingbyfeild } from "@/port/clientSide/oaExamineAudit";
import uploadFileTitle from './uploadFileTitle.vue'
import { ElMessage } from 'element-plus'
import stepOne from './stepOne.vue'
import stepTwo from './stepTwo.vue'

const uploadType = ref(1)
const uploadStep = ref(1)
const visible = ref(false)
// 文件上传配置信息
const uploadInfo = ref({})
const uploadList = ref([])

const emit = defineEmits(['confirm', 'close'])

const stepTwoRef = useTemplateRef('stepTwoRef')
const stepOneRef = useTemplateRef('stepOneRef')
 
const optionsType = [
  {
    label: 'AI自动识别上传',
    value: 1
  },
  {
    label: '文件名识别上传',
    value: 2
  }
]


const close = () => {
  visible.value = false
  uploadStep.value = 1
  uploadList.value = []
  uploadInfo.value = {}
  emit('close')
  stepOneRef.value?.reset()
  stepTwoRef.value?.reset()
}

const backStep = () => {
  uploadStep.value = 1
}

const setpOneConfirm = (value) => {
  stepOneRef.value?.reset()
  uploadList.value = value
  uploadStep.value = 2
  nextTick(() => {
    stepTwoRef.value.getListInfo()
  })
}

const stepTwoConfirm = async (param) => {
  const res = await updateapprovingfilebyfeild(param)
  if (res.code === 0) {
    const { feild, value } = param
    const title = feild.split('_')[0]
    const appProperty = uploadInfo.value.appProperty
    const control = appProperty.find(item => item.title === title)
    if (control && control.isEditParam && control.paramsLink && control.paramsLink.customize.length > 0) {
      const customize = control.paramsLink.customize
      for (const custom of customize) {
        const params = {
          approvalId: param.approvalId,
          feild: custom.conditionValue,
          value: custom.value,
          approvingId: ''
        }
        for (const item of value) {
          console.log(item,'itemitemitem')
          if (item.value.length !== 0) {
            params.approvingId = item.approvingId
            await updateapprovingbyfeild(params)
          }
        }
      }
    }
    close()
  } else {
    ElMessage.error(res.msg)
  }
}

const open = (config) => {
  uploadInfo.value = config
  visible.value = true
}

defineExpose({
  open
})
</script>

<template>
  <el-dialog v-model="visible" :style="{ '--el-dialog-padding-primary': 0 }" append-to-body :close-on-click-modal="false" fullscreen :show-close="false" :close-on-press-escape="false" class="upload-file">
    <template #header>
      <uploadFileTitle>
        <template #left>
          <div @click="close" class="upload-file-back">
            <el-icon class="icon"><ArrowLeft /></el-icon>
            <div class="name">上传文件</div>
          </div>
        </template>
        <template #right>
          <div class="upload-file-type">
            <!-- <el-segmented v-model="uploadType" :options="optionsType" :style="{ '--el-segmented-item-selected-bg-color': '#fff', '--el-segmented-item-selected-color': '#333333' }" /> -->
          </div>
        </template>
      </uploadFileTitle>
    </template>
    <div class="upload-file">
      <div class="upload-file-content">
        <template v-if="uploadStep === 1">
          <stepOne :uploadInfo="uploadInfo" ref="stepOneRef" @confirm="setpOneConfirm" />
        </template>
        <template v-else-if="uploadStep === 2">
          <stepTwo :uploadInfo="uploadInfo" ref="stepTwoRef" :uploadList="uploadList" @back="backStep" @confirm="stepTwoConfirm" />
        </template>
      </div>
    </div>
  </el-dialog>
</template>

<style scoped lang='scss'>
.upload-file {
  height: calc(100vh - 50px);
  background-color: #F9F8FE ;
  &-back {
    color: #333333;
    font-weight: 400;
    font-size: 14px;
    display: flex;
    align-items: center;
    .icon {
      color: #333333;
      margin-right: 5px;
    }
  }
  &-type {
    border-radius: 8px;
    background-color: #F3F4F6;
    display: flex;
    padding: 4px;
    box-sizing: border-box;
    height: 40px;
  }
  &-content {
    height: calc(100% - 50px);
    width: 1440px;
    margin: 0 auto;
    box-sizing: border-box;
    background-color: #fff;
  }
}
</style>
